import Refinements from './refinements';

export default Refinements;
